// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dropdown Dialog */
dialog.dialog-dropdown {
	border: none;
	border-radius: 8px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	z-index: 10;
	position: fixed;
	top: 50%;
	bottom: 50%;
}

#overlay {
	position: absolute; /* Fixed position to cover the entire viewport */
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: var(--text);
	opacity: .8;
	z-index: 5; /* Ensure the overlay is below the dialog */
	display: none; /* Initially hidden */
}

dialog {
	max-width: 80%;
	max-height: 80%;
	min-height: 150px;
	background: var(--window-bg);
	border-radius: var(--border-radius);
	color: var(--text);
	padding: 0px;
	border: none;
	overflow: hidden;
}

dialog .dialog-content {
	padding: var(--padding-sm) var(--padding-lg);
}

dialog::backdrop {
	background-color: var(--text);
	opacity: .8;
}

dialog .flex-column {
	display: flex;
	flex-direction: column;
	align-items: center;
}

dialog .x-out-div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: var(--sub-window-bg);
	border-radius: var(--border-radius) var(--border-radius) 0px 0px;
	position: sticky;
}

dialog .x-out-div h3 {
	overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 2px 10px;
}

dialog .x-out-div .cancel-btn-container button {
	margin: 0;
	border-radius: 0px 10px 0px 0px;
 }

@media (max-width: 769px) and (orientation: portrait), (max-height: 769px) and (orientation: landscape) {
	dialog {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
		top: 0;
		left: 0;
		border-radius: 0;
		margin: 0;
	}

	dialog.dialog-dropdown {
		top: 0;
		bottom: 0;
	}

}

.flex-column {
	display: flex;
	flex-direction: column;
}

`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLDialog/ECLDialog.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;CACC,YAAY;CACZ,kBAAkB;CAClB,wCAAwC;CACxC,WAAW;CACX,eAAe;CACf,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,kBAAkB,EAAE,gDAAgD;CACpE,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,6BAA6B;CAC7B,WAAW;CACX,UAAU,EAAE,2CAA2C;CACvD,aAAa,EAAE,qBAAqB;AACrC;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,4BAA4B;CAC5B,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,6BAA6B;CAC7B,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,sCAAsC;CACtC,gEAAgE;CAChE,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;CACC,SAAS;CACT,+BAA+B;CAC/B;;AAED;CACC;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,SAAS;CACV;;CAEA;EACC,MAAM;EACN,SAAS;CACV;;AAED;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB","sourcesContent":["/* Dropdown Dialog */\r\ndialog.dialog-dropdown {\r\n\tborder: none;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n\tz-index: 10;\r\n\tposition: fixed;\r\n\ttop: 50%;\r\n\tbottom: 50%;\r\n}\r\n\r\n#overlay {\r\n\tposition: absolute; /* Fixed position to cover the entire viewport */\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: var(--text);\r\n\topacity: .8;\r\n\tz-index: 5; /* Ensure the overlay is below the dialog */\r\n\tdisplay: none; /* Initially hidden */\r\n}\r\n\r\ndialog {\r\n\tmax-width: 80%;\r\n\tmax-height: 80%;\r\n\tmin-height: 150px;\r\n\tbackground: var(--window-bg);\r\n\tborder-radius: var(--border-radius);\r\n\tcolor: var(--text);\r\n\tpadding: 0px;\r\n\tborder: none;\r\n\toverflow: hidden;\r\n}\r\n\r\ndialog .dialog-content {\r\n\tpadding: var(--padding-sm) var(--padding-lg);\r\n}\r\n\r\ndialog::backdrop {\r\n\tbackground-color: var(--text);\r\n\topacity: .8;\r\n}\r\n\r\ndialog .flex-column {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n}\r\n\r\ndialog .x-out-div {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tbackground-color: var(--sub-window-bg);\r\n\tborder-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n\tposition: sticky;\r\n}\r\n\r\ndialog .x-out-div h3 {\r\n\toverflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    padding: 2px 10px;\r\n}\r\n\r\ndialog .x-out-div .cancel-btn-container button {\r\n\tmargin: 0;\r\n\tborder-radius: 0px 10px 0px 0px;\r\n }\r\n\r\n@media (max-width: 769px) and (orientation: portrait), (max-height: 769px) and (orientation: landscape) {\r\n\tdialog {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tmax-width: 100%;\r\n\t\tmax-height: 100%;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tborder-radius: 0;\r\n\t\tmargin: 0;\r\n\t}\r\n\r\n\tdialog.dialog-dropdown {\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t}\r\n\r\n}\r\n\r\n.flex-column {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
